import client from "./client";

const API = (process.env.REACT_APP_AUTH_API || "http://localhost:5000/api/auth").replace("/api/auth", "/api/conversation");

export const fetchConversations = async (page = 1, limit = 50, botId = '') => {
    let url = `${API}/list?page=${page}&limit=${limit}`;
    if (botId) url += `&botId=${botId}`;
    const res = await client.get(url);
    return res.data.conversations;
};

export const fetchConversationById = async (id) => {
    const res = await client.get(`${API}/${id}`);
    return res.data.conversation;
};

export const updateConversationStatus = async (id, status) => {
    const res = await client.patch(`${API}/${id}/status`, { status });
    return res.data;
};

export const requestLiveAgent = async (chatbotId, sessionId) => {
    const res = await client.post(`${API}/request-live`, { chatbotId, sessionId });
    return res.data;
};

export const sendAdminMessage = async (chatbotId, sessionId, text) => {
    const res = await client.post(`${API}/message`, { chatbotId, sessionId, sender: "admin", text });
    return res.data;
};

export const fetchMessagesBySession = async (chatbotId, sessionId) => {
    const res = await client.get(`${API}/session/${chatbotId}/${sessionId}`);
    return res.data;
};

export const fetchScoredLeads = async (botId = '') => {
    let url = `${API}/leads/scored`;
    if (botId) url += `?botId=${botId}`;
    const res = await client.get(url);
    return res.data;
};

export const fetchLeadStats = async (botId = '') => {
    let url = `${API}/leads/stats`;
    if (botId) url += `?botId=${botId}`;
    const res = await client.get(url);
    return res.data;
};

export const fetchContacts = async (botId = '') => {
    let url = `${API}/contacts/list`;
    if (botId) url += `?botId=${botId}`;
    const res = await client.get(url);
    return res.data;
};

export const fetchContactStats = async (botId = '') => {
    let url = `${API}/contacts/stats`;
    if (botId) url += `?botId=${botId}`;
    const res = await client.get(url);
    return res.data;
};

export const fetchContactCollectionConfig = async (botId) => {
    const res = await client.get(`${API}/contact-collection-config?botId=${botId}`);
    return res.data;
};

export const saveContactCollectionConfig = async (botId, config) => {
    const res = await client.put(`${API}/contact-collection-config`, { botId, config });
    return res.data;
};
